export const defaultFilters = {
  pagination: {
    limit: -1,
  },
}
export default function customOperatorLabel(option) {
  return option.operator_name === undefined ? undefined : `${option.operator_name}`
}
